import defaultHeaderOptions from './defaultHeaderOptions';
import { defaultHeaderOptionsFunction } from './defaultHeaderOptionsFunction';
import qs from 'qs';

export const getDataNameFromTagType = (tagType) => {
  if (tagType == "seeking") {
    return "popularSeekingTags";
  } else if(tagType == "providing") {
    return "popularProvidingTags";
  } else {
    return "tags";
  }
}

export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    if(response.status >= 500) {
      if(process.env.NODE_ENV == "production" && typeof Raven !== 'undefined') {
        Raven.captureException(response);
      }
    }
    return Promise.reject(response)
  }
}

export function parseJSON(response) {
  return response.json()
}

export function isTruthy(val) {
  return (val == true || val == "true" || val == 1);
}

export function getBaseApiUrl() {
  let userType = getUserType();
  let url = (userType == "account") ? "/api/account" : "/api";
  return url;
}

export function getBaseApiUrlFromLoggedIn() {
  return isAccountLoggedIn() ? "/api/account" : "/api";
}

export function getUserType() {
  return typeof connectspace_config != "undefined" ? "account" : "planner"
}

export function isAccountLoggedIn() {
  return isTruthy(((document.cookie.match(/^(?:.*;)?\s*bypass_site_account\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1]));
}

export function isRegistered() {
  return getUserType() == "account" && isTruthy(connectspace_config.registration_exists);
}

export function isEventRegisterable() {
  return getUserType() == "account" && isTruthy(connectspace_config.event_registerable);
}

export function handleErrors(response) {
  if(process.env.NODE_ENV == "production" && typeof Raven !== 'undefined') {
    Raven.captureException(response);
  }
  return Promise.reject(response)
}

export function newParseError(error) {
  let defaultMessage = {"message": "An error has occured. Please contact support@connectspaceinc.com."};
  let errorMessage = defaultMessage;
  try {
    error.json().then(data => {
      if(data.message != undefined) {
        try {
          errorMessage = JSON.parse(data.message);
        } catch(e) {
          errorMessage = data.message;
        }
      } else {
        errorMessage = defaultMessage;
      }
    });
  } catch(e) {
    errorMessage = defaultMessage;
  }
  return Promise.resolve(errorMessage);
}

export function parseError(data) {
  if(data.errors != undefined) {
    return data.errors;
  } else if(data.message != undefined) {
    try {
      return JSON.parse(data.message);
    } catch(e) {
      return data.message;
    }
  } else {
    return {
      "message": "An error has occured. Please contact support@connectspaceinc.com."
    }
  }
}

export function companyLocationsUrl() {
  let userType = getUserType();
  let url = `${getBaseApiUrl()}/company/addresses`;
  if(userType == "planner") {
    url = `${getBaseApiUrl()}/companies/${getCompanyId()}/addresses`;
  }
  url += "?show_metadata=true&show_company_membership=true"
  return url;
}

export function updateLocationDataUrl(companyId, addressId) {
  if(companyId) {
    return `${getBaseApiUrl()}/companies/${companyId}/addresses/${addressId}`;
  } else {
    return `${getBaseApiUrl()}/addresses/${addressId}`;
  }
}

export function updateCompanyMembershipAddressUrl() {
  return `${getBaseApiUrl()}/company/company_membership`;
}

export function createCompanyAddressUrl(companyId) {
  if(companyId) {
    return `${getBaseApiUrl()}/companies/${companyId}/addresses`;
  } else {
    return `${getBaseApiUrl()}/addresses`;
  }
}

export function newRegistrationUrl(eventSlug) {
  return `/${eventSlug}/registrations/new`;
}

export function accountTeamTagsUrl() {
  return `${getBaseApiUrl()}/team/tags`
}

export function eventAccounts(eventId) {
  return `${getBaseApiUrl()}/events/${eventId}/accounts`
}

export function teamAccountsUrl(teamId, query) {
  return `${getBaseApiUrl()}/team/${teamId}/accounts?q=${query}`;
}

export function accountSubmitTagsUrl(accountId) {
  return `${getBaseApiUrl()}/registrations/${accountId}`
}

export function myAccountTaggings(accountId) {
  return `${getBaseApiUrl()}/accounts/${accountId}/taggings?scope=all`;
}

export function submitMeetingUrl(eventId) {
  return `${getBaseApiUrl()}/events/${eventId}/meetings`;
}

export function submitOpportunityUrl(eventId) {
  return `${getBaseApiUrl()}/events/${eventId}/opportunities`;
}

export function updateOpportunityUrl(eventId, opportunityId) {
  return `${getBaseApiUrl()}/events/${eventId}/opportunities/${opportunityId}`;
}

export function submitNoteUrl() {
  return `${getBaseApiUrl()}/notes`;
}

export function updateNoteUrl(id) {
  return `${getBaseApiUrl()}/notes/${id}`;
}

export function deleteNoteUrl(id) {
  return `${getBaseApiUrl()}/notes/${id}`;
}

export function submitFulfillmentRequestUrl(eventId, opportunityId) {
  return `${getBaseApiUrl()}/events/${eventId}/opportunities/${opportunityId}/fulfillment_requests`;
}

export function updateFulfillmentRequestUrl(eventId, opportunityId, fulfillmentRequestId) {
  return `${getBaseApiUrl()}/events/${eventId}/opportunities/${opportunityId}/fulfillment_requests/${fulfillmentRequestId}`;
}

export function updateStorefrontCartLineItemUrl(storefrontId) {
  return `/api/public/storefronts/${storefrontId}/cart/set_quantity}`;
}

export function updateStorefrontEmptyCartUrl(storefrontId) {
  return `/api/public/storefronts/${storefrontId}/cart/empty`;
}

export function removeStorefrontCartLineItemUrl(storefrontId, cartLineItemId, variantId) {
  return `/api/public/storefronts/${storefrontId}/cart/remove_line_item/${cartLineItemId}?variant_id=${variantId}`;
}

export function updateStorefrontCartLineItemQuantityUrl(storefrontId, cartLineItemId, quantity) {
  return `/api/public/storefronts/${storefrontId}/cart/line_items/${cartLineItemId}/set_quantity/${quantity}`;
}

export function createStorefrontCartAddLineItemUrl(storefrontId) {
  return `/api/public/storefronts/${storefrontId}/cart/add_item`;
}

export function submitConnectionUrl() {
  return `${getBaseApiUrl()}/matches`;
}

export function newAccountUrl() {
  return `/accounts/sign_up`;
}

export function accountSignInUrl() {
  return `/accounts/sign_in`;
}

export function updateBroadcastUrl(eventId, meetingId) {
  return `/api/account/events/${eventId}/meetings/${meetingId}/update_broadcast`;
}

export function updateSessionStreamsUrl(eventId, meetingId) {
  return `/api/account/events/${eventId}/meetings/${meetingId}/update_session_streams`;
}

export function getActivityFeedUrl(eventId) {
  return `/api/account/events/${eventId}/activities`;
}

export function getCreatePostUrl(eventId) {
  return `/api/account/events/${eventId}/posts`;
}

export function deletePostUrl(eventId, postId) {
  return `/api/account/events/${eventId}/posts/${postId}`;
}

export function getSurveyUrl(survey, eventSlug) {
  if(survey.surveyable_type == "Event") {
    return `/${eventSlug}/surveys/${survey.slug}`;
  } else {
    return `/${eventSlug}/sessions/${survey.surveyable_id}/surveys/${survey.id}`;
  }
}

export function getCompanyId() {
  if(typeof connectspace_config != "undefined") {
    return connectspace_config.company_id;
  } else if(typeof notefit_config != "undefined") {
    return notefit_config.company_id;
  } else {
    return null;
  }
}

export function getCompanyName() {
  if(typeof connectspace_config != "undefined") {
    return connectspace_config.company_name;
  } else if(typeof notefit_config != "undefined") {
    return notefit_config.company_name;
  } else {
    return null;
  }
}


export function addressMetadataUrl() {
  return "/api/public/address_metadata";
}

export function getLocationMetadata(){
  return fetch(addressMetadataUrl(), {headers: defaultHeaderOptions})
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function createNewLocation(data, companyId) {
  return fetch(createCompanyAddressUrl(companyId), {
        headers: defaultHeaderOptionsFunction(),
        method: 'POST',
        body: JSON.stringify({
          address: data
        })
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function updateLocationData(data, companyId) {
  return fetch(updateLocationDataUrl(companyId, data.id), {
        headers: defaultHeaderOptionsFunction(),
        method: 'PUT',
        body: JSON.stringify({
          address: data
        })
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function setCompanyMembershipAddress(addressId) {
  return fetch(updateCompanyMembershipAddressUrl(), {
        headers: defaultHeaderOptionsFunction(),
        method: 'PUT',
        body: JSON.stringify({
          self: true,
          company_membership: {
            address_id: addressId
          }
        })
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function updateBroadcast(data, eventId, meetingId) {
  return fetch(updateBroadcastUrl(eventId, meetingId), {
        headers: defaultHeaderOptionsFunction(),
        method: 'POST',
        body: JSON.stringify(data)
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function updateSessionStreams(data, eventId, meetingId) {
  return fetch(updateSessionStreamsUrl(eventId, meetingId), {
        headers: defaultHeaderOptionsFunction(),
        method: 'POST',
        body: JSON.stringify(data)
      })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function startBroadcastUrl(eventId, meetingId) {
  return `/api/account/events/${eventId}/meetings/${meetingId}/start_broadcast`;
}

export function stopBroadcastUrl(eventId, meetingId) {
  return `/api/account/events/${eventId}/meetings/${meetingId}/stop_broadcast`;
}

export function getAccountLiveStreamsUrl(eventId, liveStreamId, page, query) {
  let url = `/api/account/events/${eventId}/live_streams/${liveStreamId}/account_live_streams?page=${page}`;
  if(query && query.length) {
    url += `&q=${query}`;
  }
  return url;
}

export function getConnectionData(eventId, liveStreamId, page, query){
  return fetch(getAccountLiveStreamsUrl(eventId, liveStreamId, page, query), {
          headers: defaultHeaderOptions,
          method: 'GET'
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function startBroadcast(eventId, meetingId){
  return fetch(startBroadcastUrl(eventId, meetingId), {
          headers: defaultHeaderOptions,
          method: 'POST'
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function getTeamAccounts(teamId, query){
  return fetch(teamAccountsUrl(teamId, query), {
          headers: defaultHeaderOptions
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function stopBroadcast(eventId, meetingId){
  return fetch(stopBroadcastUrl(eventId, meetingId), {
          headers: defaultHeaderOptions,
          method: 'POST'
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}


export function accountMeetingInvitationUrl(eventId, meetingId, meetingInvitationId) {
  return `/api/account/events/${eventId}/meetings/${meetingId}/meeting_invitations/${meetingInvitationId}/`;
}

export function updateMeetingInvitation(eventId, meetingId, meetingInvitationId, data){
  return fetch(accountMeetingInvitationUrl(eventId, meetingId, meetingInvitationId), {
          headers: defaultHeaderOptions,
          method: 'PUT',
          body: JSON.stringify(data)
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function accountMeetingUrl(eventId, meetingId) {
  return `/api/account/events/${eventId}/meetings/${meetingId}`;
}

export function updateMeeting(eventId, meetingId, data){
  return fetch(accountMeetingUrl(eventId, meetingId), {
          headers: defaultHeaderOptions,
          method: 'PUT',
          body: JSON.stringify(data)
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function getEventAccounts(eventId, params){
  let newParams = params ? qs.stringify(params, { addQueryPrefix: true, arrayFormat: 'brackets', encode: true }) : "";
  return fetch(eventAccounts(eventId) + newParams, {headers: defaultHeaderOptions})
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function getAuthPusher(authEndpointUrl) {
  return new Pusher(pusherKey, {
    authEndpoint: authEndpointUrl,
    auth: {
      headers: {
        'X-Notefit-Account-Api-Auth-Token': connectspace_config.api_auth_token,
        'CS-Team-Api-Auth-Token': connectspace_config.team_api_auth_token
      }
    }
  });
}
export function getCountFromUrl(url) {
  return fetch(url, {
    method: 'GET',
    headers: defaultHeaderOptions
  })
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
      return data
    })
    .catch(error => handleErrors(error));
}

export function startNewAccountChatUrl(eventId) {
  return `/api/account/events/${eventId}/chats`;
}

export function startNewAccountChat(data, eventId){
  return fetch(startNewAccountChatUrl(eventId), {
          headers: defaultHeaderOptions,
          method: 'POST',
          body: JSON.stringify(data)
        })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function getSingleAccountData(accountId) {
  return fetch(`/api/account/accounts/${accountId}?company=true`, {
      method: 'GET',
      headers: defaultHeaderOptions
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}


export function getActivityFeed(eventId, params) {
  let newParams = params ? qs.stringify(params, { addQueryPrefix: true, arrayFormat: 'brackets', encode: true }) : "";
  return fetch(getActivityFeedUrl(eventId) + newParams, {
      method: 'GET',
      headers: defaultHeaderOptions
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function createPostOnActivityFeed(eventId, data) {
  return fetch(getCreatePostUrl(eventId), {
    method: 'POST',
      headers: defaultHeaderOptions,
      body: JSON.stringify(data)
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function getTagsByPopular(tagType) {
  let url = `${accountTeamTagsUrl()}?sort=popular&per_page=10&sort_type=${tagType}`;
  return fetch(url, {headers: defaultHeaderOptions})
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function getAllTags(searchValue, perPage, page) {
  let url = `${accountTeamTagsUrl()}?per_page=${perPage}&sort=name`;
  if(searchValue) {
    url+= `&q=${searchValue}`;
  }
  if(page) {
    url+= `&page=${page}`;
  }
  return fetch(url, {headers: defaultHeaderOptions})
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

export function deletePostFromId(eventId, postId) {
  return fetch(deletePostUrl(eventId, postId), {
    method: 'DELETE',
      headers: defaultHeaderOptions
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        return data;
      })
      .catch(error => handleErrors(error));
}

// Storefronts

export function removeAllLineItemsWithStorefrontCart(storefrontId) {
  let url = `${updateStorefrontEmptyCartUrl(storefrontId)}`;
  return fetch(url, {
    method: 'PUT',
    headers: defaultHeaderOptions
  })
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
      return data;
    })
    .catch(error => handleErrors(error));
}

export function updateLineItemWithQuantity(storefrontId, lineItemId, quantity) {
  let url = `${updateStorefrontCartLineItemUrl()}?line_item=${lineItemId}&quantity=${quantity}`;
  return fetch(url, {
    method: 'PUT',
    headers: defaultHeaderOptions
  })
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
      tempData = { order: data.order }
      return tempData;
    })
    .catch(error => handleErrors(error));
}
